(ns machtfit.product-form.navigation
  (:require [machtfit.product-form.review :as review]
            [machtfit.product-form.section :as section]
            [re-frame.core :as rf]))

(defn scroll-to-section [id]
  (when-let [element (.getElementById js/document id)]
    (.scrollTo js/window #js {:top (.-offsetTop element)
                              :behavior "smooth"})))

(defn navigation []
  (let [view-map {:what {:label "Was"
                         :id "section-what"}
                  :where {:label "Wo"
                          :id "section-where"}
                  :when {:label "Wann"
                         :id "section-when"}
                  :for-whom {:label "Für Wen"
                             :id "section-for-whom"}
                  :who {:label "Wer"
                        :id "section-who"}
                  :how {:label "Wie"
                        :id "section-how"}
                  :resale-info {:label "Resell"
                                :id "section-resale-info"}
                  :how-much {:label "Wieviel"
                             :id "section-how-much"}
                  :visibility {:label "Zeitfenster"
                               :id "section-visibility"}
                  :promotions {:label "Aktionen"
                               :id "section-promotions"}}
        visible-sections (remove #{:save :errors} @(rf/subscribe [::section/visible-sections]))]
    (-> [:div.product-form-navigation]
        (into (interpose [:div {:role "navigation"}]
                         (map
                          (fn [section]
                            [:a
                             {:href (str "#" (-> view-map section :id))
                              :style @(rf/subscribe [::review/style-for-section section])
                              :on-click (fn [e]
                                          (.preventDefault e)
                                          (.stopPropagation e)
                                          (scroll-to-section (-> view-map section :id)))}
                             (-> view-map section :label)])

                          visible-sections))))))
